import { prop } from "fw";

export class ReadonlyField {
  @prop(null) private label;
  @prop(null) private value;
}
